import random from 'lodash/random'
import * as React from 'react'
import ContentLoader from 'react-content-loader'

import Resizable from '../../interfaces/Resizable'
import Table from './Table'

const LoadUI: React.FC<Resizable> = ({ height, width = '100%' }) => (
  <ContentLoader
    height={42}
    width={500}
    speed={2}
    primaryColor="#f3f3f3"
    secondaryColor="#ecebeb"
    style={{ height, width }}
  />
)

const TableLoader: React.FC = () => (
  <Table
    columns={[...Array(4).keys()].map((key: number) => ({
      title: '',
      dataIndex: `object${key}`,
      key: `object${key}`,
      align: 'left',
      // eslint-disable-next-line react/display-name
      render: (_text: string) => (
        <div>
          <LoadUI height="20px" width={`${random(100, 230)}px`} />
        </div>
      ),
    }))}
    dataSource={[...Array(6).keys()].map((key: number) => ({
      object0: `object0-${key}`,
      object1: `object1-${key}`,
      object2: `object2-${key}`,
      object3: `object3-${key}`,
      object4: `object4-${key}`,
    }))}
  />
)

export default TableLoader
